import { Component, AfterViewInit, ViewEncapsulation, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { Calendar } from 'primeng/calendar';
import { DiaryEventGroup } from "../../models/diary-event-group"
import { DiaryEventKeySet } from "../../utils/diary-event-key-set"

@Component({
  selector: 'mojo-calendar-month-view',
  templateUrl: './calendar-month-view.component.html',
  styleUrls: ['./calendar-month-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CalendarMonthViewComponent implements AfterViewInit {
  @Input() date: Date = null;
@ViewChild (Calendar) calendar: Calendar;
  private _diaryEvents: DiaryEventGroup[];
  private _diaryEventKeySet: DiaryEventKeySet = new DiaryEventKeySet([]);

  @Input() set diaryEvents(value: DiaryEventGroup[]) {
    this._diaryEvents = value;
    this._diaryEventKeySet = new DiaryEventKeySet(this._diaryEvents);
  }

  get diaryEvents(): DiaryEventGroup[] {
    return this._diaryEvents;
  }

  @Output() onDayClicked = new EventEmitter<Date>();

  constructor() {
  }

  ngAfterViewInit() {
    this.calendar.preventFocus = true;
  }

  dateChanged(date: Date) {
    this.onDayClicked.emit(date);
  }

  hasEvents(date: any): boolean {
    return this._diaryEventKeySet.hasPrimeNgDate(date);
  }

  getColor(date: any): string {
    return undefined;
    // Example code on how to change the style on a day basis
    //switch (date.day) {
    //  case 7:
    //    return 'rgb(68,142,227)';
    //  case 12:
    //    return 'rgb(151,221,86)';
    //  case 26:
    //    return 'rgb(245,44,169)';
    //  case 30:
    //    return 'rgb(241,169,63)';
    //}
  }
}
